import { observable } from 'mobx';

class DashboardStorage {
  @observable user = {
    loading: true,
    error: false,
    avgProgress: '',
    avgEngagement: 0,
    areaTotalUsers: '',
    conclusionPercentage: '',
    percentTotalUsers: ''
  };
}

export default new DashboardStorage();
